export const UserSvg = () => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.42675 7.66668C10.0334 7.66668 11.3334 9.28001 11.3334 11.2667V14.3333H0.666748V11.2667C0.666748 9.28001 2.00008 7.66668 3.57341 7.66668H8.42675ZM6.04008 0.333344C6.43405 0.333343 6.82415 0.410941 7.18813 0.561705C7.55211 0.712469 7.88283 0.933447 8.1614 1.21202C8.43998 1.4906 8.66096 1.82132 8.81172 2.18529C8.96248 2.54927 9.04008 2.93938 9.04008 3.33334C9.04008 3.72731 8.96248 4.11742 8.81172 4.48139C8.66096 4.84537 8.43998 5.17609 8.1614 5.45466C7.88283 5.73324 7.55211 5.95422 7.18813 6.10498C6.82415 6.25575 6.43405 6.33334 6.04008 6.33334C5.64562 6.33511 5.25472 6.25872 4.88995 6.10858C4.52517 5.95844 4.19375 5.73753 3.91483 5.4586C3.6359 5.17967 3.41499 4.84825 3.26485 4.48348C3.11471 4.11871 3.03832 3.7278 3.04008 3.33334C3.04008 2.53769 3.35615 1.77463 3.91876 1.21202C4.48137 0.649414 5.24443 0.333344 6.04008 0.333344Z"
      fill="currentColor"
    />
  </svg>
);
